import { ME } from 'query/team';
import React, { useContext } from 'react';
import { AuthenticatorContext } from 'Authenticator';
import MainLoader from './layout/MainLoader';
import { MaintenanceMessage } from './Layout';
import { useQueryCached } from './utils/graphql';
import { NEW_SESSION_PATH } from './constants';

export function withMe<TProps>(
  Cmp: React.ComponentType<TProps>,
  opts?: { ErrorCmpC?: React.JSXElementConstructor<{ error: string }>, LoadingCmpC?: React.JSXElementConstructor<any> },
) {
  const CmpRet: React.FunctionComponent<TPropsOut> = ( props: TProps ) => {
    const {isTokenValid} = useContext(AuthenticatorContext);
    const isNewSessionPage = window.location.pathname.includes(NEW_SESSION_PATH);
    const {loading, data, error} = useQueryCached(ME, {
        skip: !isTokenValid, // skip if jwt token not valid
        fetchPolicy: isNewSessionPage ? 'cache-first' : 'cache-and-network',
        nextFetchPolicy: 'cache-and-network',
        onCompleted( data ) {
          localStorage.setItem('userColorsPalette', data?.res?.colorPalette)

          const meVersion = localStorage.getItem('meVersion');

          if (!meVersion || meVersion !== String(data.res.lastUpdate)) {
            window.__APOLLO_CLIENT__.cache.reset();
            localStorage.setItem('meVersion', String(data.res.lastUpdate))
          }
        },
      }
    );

    if (error) {
      if (opts && opts.ErrorCmpC) return <opts.ErrorCmpC error={error.message}/>;
      setTimeout(() => {
        window.location.reload();
      }, 10000);
      return <MaintenanceMessage/>;
    }

    if (loading || !data) {
      if (opts && opts.LoadingCmpC) return <opts.LoadingCmpC/>;
      return <MainLoader/>;
    }

    const me = data && data.res;
    return (
      <Cmp me={me} isTeamLocked={me?.lastTeam?.locked} {...props} />
    );
  };

  type TPropsOut = Omit<TProps, 'me'>

  return ( props: TPropsOut ) => <CmpRet {...props} />;
}
